import { RootState } from '../../types';

export const all = (state: RootState) => state.finance.withdrawalMerchants;
export const list = (state: RootState) => all(state).list;
export const loading = (state: RootState) => all(state).loading;
export const error = (state: RootState) => all(state).error;
export const emptyData = (state: RootState) => all(state).emptyData;
export const init = (state: RootState) =>
  state.finance.withdrawalMerchants.init;
